import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../api/auth.service';
import { CookiesService } from '../services/cookies.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedInCookieGuard implements CanActivate {

  constructor( private authService: AuthService, private cookiesService: CookiesService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.authService.setTokenFromCookie();
    return true;
  }
}
